// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/login/Login'
import Register from '../views/Register'
import loginMen from '../components/login/loginMen'
import clearRedis from '../components/login/clearRedis'
import Index from '../components/index/Index'
import Home from '../components/index/Home'
import Set from '../components/set/set'
import Sys from '../components/set/sys'
import oa from '../components/oa/oa'
import Webshop from '../components/set/webshop'
import JieSuan from '../components/account/JieSuan'
import Yunyin from '../components/account/Yunyin'
import OrderNew from '../components/testorder/cstagreement/Order'
import WaitauditNew from '../components/workflow/waitaudit/Waitaudit'
import Store from '../components/testorder/cstagreement/Store'
import CustomService from '../components/testorder/cstagreement/CustomService'
import Buy from '../components/testorder/cstagreement/Buy'
import Machining from '../components/testorder/cstagreement/Machining'
import ManageTenantList from '../components/sysmanage/managgetenant/ManageTenantList'
import DeptListTenant from '../components/set/dept/DeptListTenant';
import ParameterMaintainList from '../components/sysmanage/parametermaintain/ParameterMaintainList'
import ExternaldeptRight from '../components/set/externaldept/ExternaldeptRight'
import appupdateList from '../components/sysmanage/parametermaintain/appupdateList'
import RunDataList from '../components/sysmanage/rundata/RunDataList'
//import Themes from '../components/theme/Themes'

const EmployeeList = () => import("@/components/set/employee/EmployeeList")
const BiMenuright = () => import("@/components/set/employee/BiMenuright")
const DeptList = () => import("@/components/set/dept/DeptList")
const JxcstoreList = () => import("@/components/set/jxcstore/JxcstoreList")
const JxcgoodscategoryList = () => import("@/components/set/jxcgoodscategory/JxcgoodscategoryList")
const JxcgoodsRight = () => import("@/components/set/jxcgoodscategory/JxcgoodsRight")
const JxcgooddetailList = () => import("@/components/set/jxcgooddetail/JxcgooddetailList")
const ExternaldeptKeHu = () => import("@/components/set/externaldept/ExternaldeptKeHu")
const ExternaldeptJingXiao = () => import("@/components/set/externaldept/ExternaldeptJingXiao")
const ExternaldeptGongYing = () => import("@/components/set/externaldept/ExternaldeptGongYing")
const GoodsPriceCost = () => import("@/components/set/goodsprice/GoodsPriceCost")
const GoodsPriceSale = () => import("@/components/set/goodsprice/GoodsPriceSale")
const GoodsPriceWarehouse = () => import("@/components/set/goodsprice/GoodsPriceWarehouse")
const GoodsPriceJingXiao = () => import("@/components/set/goodsprice/GoodsPriceJingXiao")
const GoodsStore = () => import("@/components/set/goodsprice/GoodsStore")
const SaleFavourList = () => import("@/components/set/salefavour/SaleFavourList")
const SalePricegroupList = () => import("@/components/set/salefavour/SalePricegroupList")
const SalePriceLensList = () => import("@/components/set/salefavour/SalePriceLensList")
const SalecommissionList = () => import("@/components/set/salefavour/SalecommissionList")
const Spike = () => import("@/components/set/salefavour/Spike")
const JoinGroup = () => import("@/components/set/salefavour/JoinGroup")
const SalefreightList = () => import("@/components/set/salefreight/SalefreightList")
const AuthoritySet = () => import("@/components/set/authorityset/AuthoritySet")
const InforclassList = () => import("@/components/oa/inforclass/InforclassList")
const AppHomeConfigureList = () => import("@/components/oa/AppHomeConfigure/AppHomeConfigureList")
const RechargeRecordList = () => import("@/components/set/recharge/rechargeRecordList")
const rechargeRecordDiscount = () => import("@/components/set/recharge/rechargeRecordDiscount")
const rechargeDebitList = () => import("@/components/set/recharge/rechargeDebitList")
const pointsRecordList = () => import("@/components/set/recharge/pointsRecordList")
const saleRecordList = () => import("@/components/set/recharge/saleRecordList")
const BroadcastManage = () => import("@/components/set/appimgmanage/BroadcastManage")
const BestSellersManage = () => import("@/components/set/appimgmanage/BestSellersManage")
const Upperandlower = () => import("@/components/set/upperandlower/Upperandlower.vue")
const OpLogList = () => import("@/components/set/oplog/OpLogList.vue")
const LoginLogList = () => import("@/components/set/oplog/LoginLogList.vue")
const SysMenuSet = () => import("@/components/set/oplog/SysMenuSet.vue")
const OrderList = () => import("@/components/set/oplog/OrderList.vue")
const PriceLevelManage = () => import("@/components/set/pricelevelmanage/PriceLevelManage.vue")
const Themes = () => import("@/components/theme/Themes.vue")
const SalecollageList = () => import("@/components/set/salecollage/SalecollageList.vue")
const SaleContractList = () => import("@/components/testorder/salecontract/SaleContractList.vue")
const CstagreementList = () => import("@/components/testorder/cstagreement/CstagreementList.vue")
const CstagreementListMerge = () => import("@/components/testorder/cstagreement/CstagreementListMerge.vue")
const StoreDetailListSupply = () => import("@/components/account/StoreDetailListSupply")
const StoreDetailListTraders = () => import("@/components/account/StoreDetailListTraders")
const StoreDetailListSell = () => import("@/components/account/StoreDetailListSell")
const StorageMoney = () => import("@/components/testorder/warehouse/StorageMoney")
const StoreDetailListCustomer = () => import("@/components/account/StoreDetailListCustomer")
const StoreDetailListRecharge = () => import("@/components/account/StoreDetailListRecharge")
const StoreDetailListJiXiao = () => import("@/components/account/StoreDetailListJiXiao")
const PaydetailList = () => import("@/components/account/PaydetailList")
const goodsCost = () => import("@/components/account/goodsCost")
const VoucherTJ = () => import("@/components/voucher/VoucherTJ")
const YinfuTJ = () => import("@/components/voucher/YinfuTJ")
const StoreDetailListSeed = () => import("@/components/account/StoreDetailListSeed")
const Salescommission = () => import("@/components/account/Salescommission")
const StorecostpriceSeed = () => import("@/components/account/StorecostpriceSeed")
const SupplyProfit = () => import("@/components/profit/SupplyProfit")
const BuyContractList = () => import("@/components/testorder/salecontract/BuyContractList")
const WorkflowSet = () => import("@/components/set/workflow/WorkflowSet")
const PayFeeType = () => import("@/components/set/workflow/PayFeeType")

const Workload = () => import("@/components/testorder/cstagreement/Workload.vue")
const Workload2 = () => import("@/components/testorder/cstagreement/Workload2.vue")
const Workload3 = () => import("@/components/testorder/cstagreement/Workload3.vue")
const XianPianApp = () => import("@/components/testorder/cstagreement/XianPianApp.vue")
const ZuoYouYanApp = () => import("@/components/testorder/cstagreement/ZuoYouYanApp.vue")
const HsZuoYouYanApp = () => import("@/components/testorder/cstagreement/HsZuoYouYanApp.vue")
const HsXianPianApp = () => import("@/components/testorder/cstagreement/HsXianPianApp.vue")
const HsTuiHuoXianPianApp = () => import("@/components/testorder/cstagreement/HsTuiHuoXianPianApp.vue")
const HsTuiHuoXianPianAppch = () => import("@/components/testorder/cstagreement/HsTuiHuoXianPianAppch.vue")
const HsTuiHuoJingJiaApp = () => import("@/components/testorder/cstagreement/HsTuiHuoJingJiaApp.vue")
const emptyVue = () => import("@/components/testorder/cstagreement/emptyVue.vue")
const TestAPI = () => import("@/components/common/TestAPI.vue")
const OSSIempower  = () => import("@/components/set/pricelevelmanage/OSSIempower.vue")
const BIlogin = () => import("@/components/login/bilogin")
const Store4BI = () => import("@/components/testorder/cstagreement/Store4BI")


const Reimbursement = () => import("@/components/oa/payform/Reimbursement")
const Payments = () => import("@/components/oa/payform/Payments")
const PayAccount = () => import("@/components/oa/payform/PayAccount")
const Paymethod = () => import("@/components/oa/payform/Paymethod")
const buyorderbi = () =>import("@/components/testorder/buyagreement/BuyorderDetail4BI")
const inventoryorderbi = () =>import("@/components/warehouse/MakeInventory4BI")
const badoutorderbi = () =>import("@/components/warehouse/StorageBadOut4BI")
const inveorderbi  = () =>import("@/components/set/recharge/inveorderbi")

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  mode: "hash",
  // base: '/hot/', //2018-6-30  不然打包之后部署tomcat如果无法访问路由，加上这句。hot是tomcat中的根路径所在文件夹名，也可以修改。
  routes: [
    {
      name: "index", path: '/index', component: Index, meta: {requiresAuth: true},
      children: [
        {path: "", component: Home},
        {path: 'home', component: Home, name: 'home'},
        {path: 'clearredis', component: clearRedis, name: 'clearredis'},
        {name: "SupplyProfit", component: SupplyProfit, path: "SupplyProfit", meta: {requiresSupplyAuth: true}},//供应商利润页面
        {path: 'waitaudlt', component: WaitauditNew, name: 'waitaudlt'},
        {
          path: 'JieSuan', component: JieSuan, name: 'JieSuan', children: [
            {name: "CstagreementList", component: CstagreementList, path: "CstagreementList"},
            {name: "CstagreementListMerge", component: CstagreementListMerge, path: "CstagreementListMerge"},
            {path: "RechargeRecordList", component: RechargeRecordList, name: "RechargeRecordList"},
            {path: "rechargeRecordDiscount", component: rechargeRecordDiscount, name: "rechargeRecordDiscount"},
            {path: "pointsRecordList", component: pointsRecordList, name: "pointsRecordList"},
            {path: "rechargeDebitList", component: rechargeDebitList, name: "rechargeDebitList"},
            {name: "StoreDetailListSupply", component: StoreDetailListSupply, path: "StoreDetailListSupply"},
            {name: "StoreDetailListSell", component: StoreDetailListSell, path: "StoreDetailListSell"},
            {name: "StorageMoney", component: StorageMoney, path: "StorageMoney"},
            {name: "StoreDetailListTraders", component: StoreDetailListTraders, path: "StoreDetailListTraders"},
            {name: "StoreDetailListCustomer", component: StoreDetailListCustomer, path: "StoreDetailListCustomer"},
            {name: "StoreDetailListRecharge", component: StoreDetailListRecharge, path: "StoreDetailListRecharge"},
            {name: "StoreDetailListJiXiao", component: StoreDetailListJiXiao, path: "StoreDetailListJiXiao"},
            {name: "PaydetailList", component: PaydetailList, path: "PaydetailList"},
            {name: "goodsCost", component: goodsCost, path: "goodsCost"},
            {name: "VoucherTJ", component: VoucherTJ, path: "VoucherTJ"},
            {name: "YinfuTJ", component: YinfuTJ, path: "YinfuTJ"},
            {name: "StoreDetailListSeed", component: StoreDetailListSeed, path: "StoreDetailListSeed"},
            {name: "Salescommission", component: Salescommission, path: "Salescommission"},
            {name: "StorecostpriceSeed", component: StorecostpriceSeed, path: "StorecostpriceSeed"},
            {name: "SaleContractList", component: SaleContractList, path: "SaleContractList"},
            {name: "Workload2", component: Workload2, path: "Workload2"},
            {name: "Workload3", component: Workload3, path: "Workload3"},
          ]
        },
        {
          path: 'Yunyin', component: Yunyin, name: 'Yunyin', children: [
            {name: "Workload", component: Workload, path: "Workload"},
          ]
        },
        {
          path: 'oa', component: oa, name: 'oa', children: [
            {path: "Reimbursement", component: Reimbursement, name: "Reimbursement"},
            {path: "Payments", component: Payments, name: "Payments"},
            {path: "PayAccount", component: PayAccount, name: "PayAccount"},
          ]
        },
        {
          path: 'set', component: Set, name: 'set', children: [
            {path: "EmployeeList", component: EmployeeList, name: "EmployeeList"},
            {path: "BiMenuright", component: BiMenuright, name: "BiMenuright"},
            {path: "JxcstoreList", component: JxcstoreList, name: "JxcstoreList"},
            {path: "DeptList", component: DeptList, name: "DeptList"},
            {path: "JxcgoodsRight", component: JxcgoodsRight, name: "JxcgoodsRight"},
            {path: "JxcgooddetailList", component: JxcgooddetailList, name: "JxcgooddetailList"},
            {path: "ExternaldeptKeHu", component: ExternaldeptKeHu, name: "ExternaldeptKeHu"},
            {path: "ExternaldeptJingXiao", component: ExternaldeptJingXiao, name: "ExternaldeptJingXiao"},
            {path: "ExternaldeptGongYing", component: ExternaldeptGongYing, name: "ExternaldeptGongYing"},
            {path: "GoodsPriceCost", component: GoodsPriceCost, name: "GoodsPriceCost"},
            {path: "BuyContractList", component: BuyContractList, name: "BuyContractList"},
            {path: "GoodsPriceSale", component: GoodsPriceSale, name: "GoodsPriceSale"},
            {path: "GoodsPriceWarehouse", component: GoodsPriceWarehouse, name: "GoodsPriceWarehouse"},
            {path: "GoodsPriceJingXiao", component: GoodsPriceJingXiao, name: "GoodsPriceJingXiao"},
            {path: "GoodsStore", component: GoodsStore, name: "GoodsStore"},
            {path: "SaleFavourList", component: SaleFavourList, name: "SaleFavourList"},
            {path: "SalefreightList", component: SalefreightList, name: "SalefreightList"},
            {path: "AuthoritySet", component: AuthoritySet, name: "AuthoritySet"},
            {path: "AppHomeConfigureList", component: AppHomeConfigureList, name: "AppHomeConfigureList"},
            {path: "BroadcastManage", component: BroadcastManage, name: "BroadcastManage"},
            {path: "Upperandlower", component: Upperandlower, name: "Upperandlower"},
            {path: "BestSellersManage", component: BestSellersManage, name: "BestSellersManage"},
            {path: "OpLogList", component: OpLogList, name: "OpLogList"},
            {path: "SysMenuSet", component: SysMenuSet, name: "SysMenuSet"},
            {path: "SalePriceLensList", component: SalePriceLensList, name: "SalePriceLensList"},
            {path: "SalecommissionList", component: SalecommissionList, name: "SalecommissionList"},
            {path: "LoginLogList", component: LoginLogList, name: "LoginLogList"},
            {path: "SaleContractList", component: SaleContractList, name: "SaleContractList"},
            {path: "OrderList", component: OrderList, name: "OrderList"},
            {path: "PriceLevelManage", component: PriceLevelManage, name: "PriceLevelManage"},
            {path: "SalecollageList", component: SalecollageList, name: "SalecollageList"},
            {path: "OSSIempower", component: OSSIempower, name: "OSSIempower"},
            {path: 'ExternaldeptRight', component: ExternaldeptRight, name: 'ExternaldeptRight'},
            {path: 'Themes', component: Themes, name: 'Themes'}
          ]
        },
        {
          path: 'webshop', component: Webshop, name: 'webshop', children: [
            {path: "SalePricegroupList", component: SalePricegroupList, name: "SalePricegroupList"},
            {path: "Spike", component: Spike, name: "Spike"},
            {path: "JoinGroup", component: JoinGroup, name: "JoinGroup"},
            {path: "saleRecordList", component: saleRecordList, name: "saleRecordList"},
          ]
        },
        {
          path: 'sys', component: Sys, name: 'sys', children: [
            {path: "JxcgoodscategoryList", component: JxcgoodscategoryList, name: "JxcgoodscategoryList"},
            {path: 'ManageTenantList', component: ManageTenantList, name: 'ManageTenantList'},
            {path: 'DeptListTenant', component: DeptListTenant, name: 'DeptListTenant'},
            {path: 'ParameterMaintainList', component: ParameterMaintainList, name: 'ParameterMaintainList'},
            {path: 'appupdateList', component: appupdateList, name: 'appupdateList'},
            {path: 'RunDataList', component: RunDataList, name: 'RunDataList'},
            {path: 'WorkflowSet', component: WorkflowSet, name: 'WorkflowSet'},
            {path: "InforclassList", component: InforclassList, name: "InforclassList"},
            {path: 'Paymethod', component: Paymethod, name: 'Paymethod'},
            {path: 'PayFeeType', component: PayFeeType, name: 'PayFeeType'}
          ]
        },
        {path: 'testorder', component: OrderNew, name: 'testorder'},
        {path: 'customservice', component: CustomService, name: 'customservice'},
        {path: 'machining', component: Machining, name: 'machining'},
        {path: 'store', component: Store, name: 'store'},
        {path: 'buy', component: Buy, name: 'buy'},
        /* {path: 'Themes', component: Themes, name: 'Themes'},*/
      ]
    },
    {name: "login", path: '/login', component: Login},
    {name: "Register", path: '/Register', component: Register},
    {name: "loginMen", path: '/loginMen', component: loginMen},
    {name: "xianpianapp", path: '/app/XianPian', component: XianPianApp, meta: {requiresWebAuth: true}},
    {name: "zuoyouyanapp", path: '/app/ZuoYouYanApp', component: ZuoYouYanApp, meta: {requiresWebAuth: true}},
    {name: "HsXianPianApp", path: '/app/HsXianPianApp', component: HsXianPianApp, meta: {requiresWebAuth: true}},
    {name: "HsZuoYouYanApp", path: '/app/HsZuoYouYanApp', component: HsZuoYouYanApp, meta: {requiresWebAuth: true}},
    {
      name: "HsTuiHuoXianPianApp",
      path: '/app/HsTuiHuoXianPianApp',
      component: HsTuiHuoXianPianApp,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsTuiHuoXianPianAppch",
      path: '/app/HsTuiHuoXianPianAppch',
      component: HsTuiHuoXianPianAppch,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsTuiHuoJingJiaApp",
      path: '/app/HsTuiHuoJingJiaApp',
      component: HsTuiHuoJingJiaApp,
      meta: {requiresWebAuth: true}
    },
    {name: "emptyVue", path: '/app/emptyVue', component: emptyVue, meta: {requiresWebAuth: true}},
    {
      name: "default", path: '/', component: Index, meta: {requiresAuth: true},
      children: [
        {path: "", component: Home},
      ]
    },
    {
      name: "testapi", path: '/testapi', component: TestAPI, meta: {requiresAuth: true}
    },
    {
      name: "bilogin", path: '/bilogin', component: BIlogin, meta: {requiresBIframeAuth: true},
      children: []
    },
    {name: "biworkload", component: Workload, path: "biworkload", meta: {requiresBIframeAuth: true}},//工作量
    {name: "biworkloadV2", component: Workload2, path: "biworkloadV2", meta: {requiresBIframeAuth: true}},//工作量
    {name: "biworkloadV3", component: Workload3, path: "biworkloadV3", meta: {requiresBIframeAuth: true}},//工作量
    {name: "birecharge", path: "birecharge", component: RechargeRecordList, meta: {requiresBIframeAuth: true}},//收款日志
    {name: "bicustomer", component: StoreDetailListCustomer, path: "bicustomer", meta: {requiresBIframeAuth: true}},//客户
    {name: "bisupply", component: StoreDetailListSupply, path: "bisupply", meta: {requiresBIframeAuth: true}},//供应商
    {name: "bigoods", component: StoreDetailListSeed, path: "bigoods", meta: {requiresBIframeAuth: true}},//产品统计
    {name: "bicommission", component: Salescommission, path: "bicommission", meta: {requiresBIframeAuth: true}},//产品 销售提成
    {name: "bicost", component: StorecostpriceSeed, path: "bicost", meta: {requiresBIframeAuth: true}},//成本统计
    {name: "bistorage", component: StorageMoney, path: "bistorage", meta: {requiresBIframeAuth: true}},//存货
    {name: "bicangku", component: Store4BI, path: "bicangku", meta: {requiresBIframeAuth: true}},//库存查询
    {name: "bifee", component: PaydetailList, path: "bifee", meta: {requiresBIframeAuth: true}},//费用查询
    {name: "bisell", component: StoreDetailListSell, path: "bisell", meta: {requiresBIframeAuth: true}},//连锁店
    {name: "bipay", component: Payments, path: "bipay", meta: {requiresBIframeAuth: true}},//付款申请单
    {name: "buyorderbi", component: buyorderbi, path: "buyorderbi", meta: {requiresBIframeAuth: true}},//采购单 表单页面
    {name:"inventoryorderbi", component: inventoryorderbi, path: "inventoryorderbi", meta: {requiresBIframeAuth: true}},//盘点单 表单页面
    {name:"badoutorderbi", component: badoutorderbi, path: "badoutorderbi", meta: {requiresBIframeAuth: true}},//坏件出库单 表单页面
    {name:"inveorderbi",component:inveorderbi,path:"inveorderbi", meta: {requiresBIframeAuth: true}}
  ]
})

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresSupplyAuth)) {
    let tokenmodel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
    if (localStorage.getItem("hpapi_token") && tokenmodel.loginfrom == "supply") {
      next()
    } else {
      next({
        name: 'loginsupply',
        params: {redirect: to.fullPath}
      })
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    //let tokenmodel = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
    // 这个判断先去掉，单点登录跳转过来时，还没取到tokenmodel：
    // tokenmodel.loginfrom == "pc"
    if (localStorage.getItem("hpapi_token") || to.query.token) {
      next()
    } else if (localStorage.getItem("hpapi_token") == null) {
      next({
        name: 'login',
        params: {redirect: to.fullPath}
      })
    } else {
      next({
        name: 'login',
        params: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

//返回router对象
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js